// In videoUploadTrackingSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VideoUploadTrackingState {
  activeUploads: number;
  updatePathOperationsInProgress: number;
  uploadSequenceInProgress: boolean;
}

const initialState: VideoUploadTrackingState = {
  activeUploads: 0,
  updatePathOperationsInProgress: 0,
  uploadSequenceInProgress: false
};

export const videoUploadTrackingSlice = createSlice({
  name: 'videoUploadTracking',
  initialState,
  reducers: {
    // Use default parameters in the function definition instead of trying to set a default PayloadAction
    incrementPendingUploads: (state, action: PayloadAction<number>) => {
      const increment = action.payload || 1; // Use default value here
      state.activeUploads += increment;
    },
    decrementPendingUploads: state => {
      state.activeUploads = Math.max(0, state.activeUploads - 1);
    },
    resetPendingUploads: state => {
      state.activeUploads = 0;
    },
    // Same pattern for the new reducers
    incrementUpdatePathOperations: (state, action: PayloadAction<number>) => {
      const increment = action.payload || 1; // Use default value here
      state.updatePathOperationsInProgress += increment;
    },
    decrementUpdatePathOperations: state => {
      state.updatePathOperationsInProgress = Math.max(
        0,
        state.updatePathOperationsInProgress - 1
      );
    },
    startUploadSequence: state => {
      state.uploadSequenceInProgress = true;
    },
    completeUploadSequence: state => {
      if (state.activeUploads === 0) {
        state.uploadSequenceInProgress = false;
      }
    }
  }
});

export const {
  incrementPendingUploads,
  decrementPendingUploads,
  resetPendingUploads,
  incrementUpdatePathOperations,
  decrementUpdatePathOperations,
  startUploadSequence,
  completeUploadSequence
} = videoUploadTrackingSlice.actions;

export default videoUploadTrackingSlice.reducer;
